import React from "react";
import FormContents from "./FormContents";

export const TrainEventRecordFormContents = () => {
    return (
        <FormContents></FormContents>
    );
};